/**
 * Web stub for useSubscriptionRecovery.
 * IAP subscription recovery is only applicable on iOS/Android native platforms.
 */
export function useSubscriptionRecovery() {
  // No-op on web - IAP is not available
}

export default useSubscriptionRecovery;
